'use client'

import BenefitsSlider from '../../../blocks/BenefitsSlider'
import CareerOpenings from '../../../blocks/CareerOpenings'
import CenterBulletPoints from '../../../blocks/CenterBulletPoints'
import CenterContent from '../../../blocks/CenterContent'
import ContentBlockOne from '../../../blocks/ContentBlockOne'
import ContentBlockTwo from '../../../blocks/ContentBlockTwo'
import ContentImage from '../../../blocks/ContentImage'
import ContrastHeritageGrid from '../../../blocks/ContrastHeritageGrid'
import DarkFooterCTA from '../../../blocks/DarkFooterCTA'
import DarkResourcesGallery from '../../../blocks/DarkResourcesGallery'
// import DemoCTA from '../../../blocks/DemoCTA'
import DemonstrationForm from '../../../blocks/DemonstrationForm'
import DescriptionImage from '../../../blocks/DescriptionImage'
import DiagramCluster from '../../../blocks/DiagramCluster'
import Divider from '../../../blocks/Divider'
import DualColumnFeaturesGrid from '../../../blocks/DualColumnFeaturesGrid'
import DualColumnInfo from '../../../blocks/DualColumnInfo'
import EnterpriseDiagram from '../../../blocks/EnterpriseDiagram'
import FAQTooltips from '../../../blocks/FAQTooltips'
import FeatureLinkGrid from '../../../blocks/FeatureLinkGrid'
import FeaturedProductList from '../../../blocks/FeaturedProductList'
import FeaturedSolutionList from '../../../blocks/FeaturedSolutionList'
import FullWidthDynamicBlock from '../../../blocks/FullWidthDynamicBlock'
import FullWidthImage from '../../../blocks/FullWidthImage'
import InfoCalloutImage from '../../../blocks/InfoCalloutImage'
import InfoColumnImage from '../../../blocks/InfoColumnImage'
import InfoVideoCTAButton from '../../../blocks/InfoVideoCTAButton'
import IntCluster from '../../../blocks/IntCluster'
import LightTabbedFeatures from '../../../blocks/LightTabbedFeatures'
import LineList from '../../../blocks/LineList'
import MessageDarkHighlight from '../../../blocks/MessageDarkHighlight'
import OfficesList from '../../../blocks/OfficesList'
import PairImageCallout from '../../../blocks/PairImageCallout'
import PartialHeader from '../../../blocks/PartialHeader'
import PartnerLogoSlider from '../../../blocks/PartnerLogoSlider'
import ProductHighlight from '../../../blocks/ProductHighlight'
import ProductLifecycle from '../../../blocks/ProductLifecycle'
import QuickLinksCallout from '../../../blocks/QuickLinksCallout'
import SnippetsInfoImage from '../../../blocks/SnippetsInfoImage'
import SolutionsCalloutText from '../../../blocks/SolutionsCalloutText'
import SplitCTA from '../../../blocks/SplitCTA'
import SplitInfoDiagram from '../../../blocks/SplitInfoDiagram'
import StandaloneHeaderCluster from '../../../blocks/StandaloneHeaderCluster'
import SubscribeToNucleusCTA from '../../../blocks/SubscribeToNucleusCTA'
import SupportForm from '../../../blocks/SupportForm'
import SupportPlansGrid from '../../../blocks/SupportPlansGrid'
import TabbedDiagram from '../../../blocks/TabbedDiagram'
import TitleDarkHighlight from '../../../blocks/TitleDarkHighlight'
import TrioLinkCTA from '../../../blocks/TrioLinkCTA'
import TypeformEmbed from '../../../blocks/TypeformEmbed'
import VideoHighlight from '../../../blocks/Videohighlight'
import WatchVideoCTA from '../../../blocks/WatchVideoCTA'
import LeadCapture from '../../../components/LeadCapture'
import FormBlock from '../../blocks/FormBlock'
import GenericCTA from '../../blocks/GenericCTA'
import { ReusableBlock } from '../../blocks/ReusableBlock'
import { Page, ReusableBlock as ReusableBlockType } from '@telesoft/types/payload-types'
import React, { Fragment } from 'react'
import { Form } from 'react-hook-form'
import { RichText } from '../RichText'

type ReusableContentBlockType = Extract<Page['blocks'][0], { blockType: 'reusable-blocks' }>

const blockComponents = {
  'partner-logo-slider': PartnerLogoSlider,
  'info-callout-image': InfoCalloutImage,
  'content-block-one': ContentBlockOne,
  'content-block-two': ContentBlockTwo,
  'content-image': ContentImage,
  'center-content': CenterContent,
  'int-cluster': IntCluster,
  'trio-link-cta': TrioLinkCTA,
  'tabbed-diagram': TabbedDiagram,
  'feature-link-grid': FeatureLinkGrid,
  'product-highlight': ProductHighlight,
  'product-lifecycle': ProductLifecycle,
  'pair-image-callout': PairImageCallout,
  // 'demo-cta': DemoCTA,
  'description-image': DescriptionImage,
  'dark-footer-cta': DarkFooterCTA,
  'watch-video-cta': WatchVideoCTA,
  'offices-list': OfficesList,
  'generic-cta': GenericCTA,
  'demonstration-form': DemonstrationForm,
  'lead-capture': LeadCapture,
  'quick-links-callout': QuickLinksCallout,
  'dual-column-info': DualColumnInfo,
  'light-tabbed-features': LightTabbedFeatures,
  'partial-header': PartialHeader,
  'dual-column-features-grid': DualColumnFeaturesGrid,
  'dark-resources-gallery': DarkResourcesGallery,
  'split-info-diagram': SplitInfoDiagram,
  'snippets-info-image': SnippetsInfoImage,
  'contrast-heritage-grid': ContrastHeritageGrid,
  'video-highlight': VideoHighlight,
  'split-cta': SplitCTA,
  'reusable-blocks': ReusableBlock,
  'featured-product-list': FeaturedProductList,
  'featured-solution-list': FeaturedSolutionList,
  'line-list': LineList,
  'info-column-image': InfoColumnImage,
  form: FormBlock,
  divider: Divider,
  'full-width-dynamic-block': FullWidthDynamicBlock,
  'subscribe-to-nucleus-cta': SubscribeToNucleusCTA,
  'support-form': SupportForm,
  'support-plans-grid': SupportPlansGrid,
  'career-openings': CareerOpenings,
  'standalone-header-cluster': StandaloneHeaderCluster,
  'solutions-callout-text': SolutionsCalloutText,
  'info-video-cta-button': InfoVideoCTAButton,
  'faq-tooltips': FAQTooltips,
  'message-dark-highlight': MessageDarkHighlight,
  'title-dark-highlight': TitleDarkHighlight,
  'richer-text': RichText,
  'diagram-cluster': DiagramCluster,
  'enterprise-diagram': EnterpriseDiagram,
  'benefits-slider': BenefitsSlider,
  'full-width-image': FullWidthImage,
  'center-bullet-points': CenterBulletPoints,
  'form-old': Form,
  'typeform-embed': TypeformEmbed,
}

type Props = {
  blocks: (ReusableBlockType['blocks'][0] | ReusableContentBlockType)[]
  disableOuterSpacing?: true
}

export const RenderBlocks: React.FC<Props> = props => {
  const { blocks, disableOuterSpacing } = props
  const hasBlocks = blocks && Array.isArray(blocks) && blocks.length > 0

  if (hasBlocks) {
    return (
      <Fragment>
        {blocks.map((block, index) => {
          const { blockName, blockType } = block

          if (blockType && blockType in blockComponents) {
            // @ts-ignore
            const Block = blockComponents[blockType]

            const hasSpacing = !['banner'].includes(blockType)

            let topSpacing = hasSpacing
            let bottomSpacing = hasSpacing

            if (disableOuterSpacing && hasSpacing) {
              if (index === 0) topSpacing = false
              if (index === blocks.length - 1) bottomSpacing = false
            }

            if (Block) {
              return <Block key={`${blockName}-${index}`} id={blockName} {...block} />
            }
          }
          return null
        })}
      </Fragment>
    )
  }

  return null
}
